<div class="filters-wrapper">
  <div>
    <div class="selector-div-wrapper">
      <span>Mostrar</span>
      <div class="form-check form-switch">
        <input class="input-switch-sm form-check-input" type="checkbox" role="switch" id="searcher-switch"
          [(ngModel)]="tool.enabled" [checked]="tool.enabled" />
      </div>
    </div>
    <div *ngIf="tool.enabled" class="tool-enabled-wrapper">
      <div class="selector-div-wrapper p-0">
        <span>Tipo</span>
        <div class="selector-div">
          <select name="selector" class="selector" [(ngModel)]="tool.integration.defaultmode.active">
            <option [ngValue]="true">Default</option>
            <option [ngValue]="false">Legend</option>
          </select>
          <div class="vertical-line"></div>
        </div>
      </div>
      <div class="tabs mt-2">
        <div class="tab">
          <button (click)="tabs.active = 'filtergeneration'" [ngClass]="{ active: tabs.active === 'filtergeneration' }">
            Filtros
          </button>
        </div>
        <div class="tab">
          <button (click)="tabs.active = 'files'" [ngClass]="{ active: tabs.active === 'files' }">Ficheros</button>
        </div>
        <div class="tab">
          <button (click)="tabs.active = 'colors'" [ngClass]="{ active: tabs.active === 'colors' }">Colores</button>
        </div>
      </div>
      <!-- Filter generation -->
      <app-filter-generation [tool]="tool" #filtergeneration
        [hidden]="tabs.active !== 'filtergeneration'"></app-filter-generation>
      <!-- Menu filters files: Download / Upload -->
      <app-filterfiles *ngIf="tabs.active === 'files'" [tool]="tool"
        (finishParse)="finishedUpload($event)"></app-filterfiles>
      <!-- Interface Colors -->
      <app-menucolors *ngIf="tabs.active === 'colors'" [tool]="tool"></app-menucolors>
    </div>
    <div class="applychanges-bottom">
      <button class="btn-secondary-action" (click)="save()">Aplicar cambios</button>
    </div>
  </div>
  <div [ngClass]="{ 'd-none': sidebar?.grid.extended === false }">
    <!-- Add here components to show expanded-->
  </div>
</div>